import { useState, useEffect, useRef } from "react";
import { authService } from "../../auth/services/authService";

export const useResetPassword = (token, navigate) => {
  const isMounted = useRef(true);
  const [userData, setUserData] = useState({
    success: false,
    email: "",
    role: "",
  });
  const [passwords, setPasswords] = useState({ new: "", confirm: "" });
  const [status, setStatus] = useState({
    loading: true,
    message: "",
    isError: false,
  });

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (!token) {
      setStatus({
        loading: false,
        message: "Invalid reset link.",
        isError: true,
      });
      return;
    }

    const verifyToken = async () => {
      try {
        const data = await authService.verifyResetToken(token);
        if (!isMounted.current) return;
        setUserData(data);
        setStatus((prev) => ({ ...prev, loading: false }));
      } catch (err) {
        if (!isMounted.current) return;
        setStatus({
          loading: false,
          message: "Invalid or expired reset link.",
          isError: true,
        });
      }
    };

    verifyToken();
  }, [token]);

  const handleUpdatePassword = async () => {
    if (!passwords.new || !passwords.confirm) {
      return setStatus({
        loading: false,
        message: "Please fill in all fields.",
        isError: true,
      });
    }
    if (passwords.new.length < 8) {
      return setStatus({
        loading: false,
        message: "Password must be at least 8 characters.",
        isError: true,
      });
    }
    if (passwords.new !== passwords.confirm) {
      return setStatus({
        loading: false,
        message: "Passwords do not match.",
        isError: true,
      });
    }

    setStatus({ loading: true, message: "", isError: false });

    try {
      const res = await authService.resetPassword(token, passwords.new);
      if (!isMounted.current) return;

      if (res.success) {
        setStatus({
          loading: false,
          message: "Password updated successfully!",
          isError: false,
        });
        setTimeout(() => {
          if (isMounted.current) navigate("/sign-in");
        }, 2000);
      }
    } catch (err) {
      if (!isMounted.current) return;
      setStatus({
        loading: false,
        message:
          err.response?.data?.message || "Server error. Please try again.",
        isError: true,
      });
    }
  };

  return { userData, passwords, setPasswords, status, handleUpdatePassword };
};
